var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 980",
    d: "M13.625 3.625L13.1602 11.1438C13.0415 13.0648 12.9821 14.0253 12.5006 14.7159C12.2625 15.0573 11.956 15.3455 11.6005 15.562C10.8816 16 9.91924 16 7.99456 16C6.06734 16 5.10373 16 4.38429 15.5612C4.0286 15.3443 3.722 15.0556 3.48401 14.7136C3.00266 14.0219 2.94459 13.0601 2.82846 11.1364L2.375 3.625",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.25 3.625H14.75M11.0418 3.625L10.5298 2.5688C10.1897 1.86719 10.0196 1.51639 9.72628 1.2976C9.66122 1.24907 9.59232 1.20591 9.52027 1.16853C9.19543 1 8.80559 1 8.0259 1C7.22662 1 6.82699 1 6.49676 1.17559C6.42357 1.21451 6.35374 1.25942 6.28797 1.30988C5.99123 1.53753 5.82547 1.90116 5.49395 2.62844L5.03969 3.625",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 5",
    d: "M6.125 11.875L6.125 7.375",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 6",
    d: "M9.875 11.875L9.875 7.375",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.938100a035c4b0c18b7df8354c93700b.svg";
export { ForwardRef as ReactComponent };